import React, { useEffect, useState, lazy, Suspense } from "react";
import ContentBox from "../components/contents/ContentBox";
import LoadingIndicator from "../components/LoadingIndicator";
import PageWrapper from "../components/PageWrapper";
import SortByTag from "../components/SortByTag";
import ProductAddForm from "../components/addProduct";
import { getData } from "../FatchApi/FatchApi";
import RecipeAddForm from "../components/RecipesAdd";
//import BlogAddForm from "../components/BlogAddForm";

const Recipe = lazy(() => import("../components/Recipe/Recipe"));

const ManageRecipe = () => {
  const [show, setshow] = useState(true);
  const [Recipes, setRecipes] = useState([]);
  const [editID, setEditID] = useState(null);

  // Fetch products from server
  const getAllRecipe = async () => {
    const res = await getData("api/recipe/get-all-recipe");
    // console.log(res.blogs);
    setRecipes(res.recipes);
  };
  useEffect(() => {
    getAllRecipe();
  }, []);

  const openhandler = () => {
    setshow(!show);
    setEditID(false);
  };

  return (
    <PageWrapper>
      <div className="w-full">
        {show ? (
          <div style={{ display: "flex" }}>
            <div>
              <h1 className="text-lg text-gray-100 font-bold leading-5">
                Sapphire Dry Nuts Recipes
              </h1>
              <p className="text-gray-300 leading-5">
                Enhance your business by sharing your store URL.
              </p>
            </div>
            <div className="text-right" style={{ marginLeft: "auto" }}>
              <button
                className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
                onClick={() => openhandler()}
              >
                Add Recipe +
              </button>
            </div>
          </div>
        ) : (
          <div className="text-right">
            <button
              className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
              onClick={() => setshow(!show)}
            >
              Show All Recipes
            </button>
          </div>
        )}

        {!show ? (
          <RecipeAddForm id={editID}></RecipeAddForm>
        ) : (
          <ContentBox name="Active Recipes">
            <>
              <div className="border-b border-b-glitch-box">
                <SortByTag tags={[]} />
              </div>

              {/* Products list */}
              <div className="mt-5"></div>
              <Suspense fallback={<LoadingIndicator />}>
                <ul className="sm:px-5 px-1 bg-transparent">
                  {Recipes &&
                    Recipes.map((res, i) => (
                      <li
                        className="block mt-4 pb-4 border-b border-b-glitch-box last:border-none"
                        key={i}
                      >
                        <Recipe
                          data={res}
                          onchange={getAllRecipe}
                          setshow={setshow}
                          setEditID={setEditID}
                        />
                      </li>
                    ))}
                </ul>
              </Suspense>
            </>
          </ContentBox>
        )}
      </div>
    </PageWrapper>
  );
};

export default ManageRecipe;
